import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { OrderSocketService } from "src/app/core/services/order-socket.service";
import { OOStyles } from "src/app/shared/models/oo-styles";

@Component({
	selector: "app-order-status",
	templateUrl: "./order-status.component.html",
	styleUrls: ["../../online-order.component.scss"],
})
export class OrderStatusComponent implements OnInit, OnDestroy {
	@Input() ooStyles: OOStyles;
	@Input() isFutureOrder: boolean = false;
	@Output() orderCompleteEmitter = new EventEmitter<string>();
	orderSteps = {
		assembled: false,
		authorized: false,
		submitted: false,
		queued: false,
		sentToPos: false,
		injected: false,
		mobileCheckSave: false,
	};

	orderProgress: number = 0;

	orderRequiresPayment: boolean = true;

	orderStatusSubscription: Subscription;

	constructor(private orderService: OrderSocketService) {}

	ngOnInit(): void {
		console.log("init orderStatusComponent");
		this.orderStatusSubscription = this.orderService.orderStatus.subscribe(async (data) => {
			this.orderStatusChange(data);
		});
	}

	ngOnDestroy() {
		this.orderStatusSubscription.unsubscribe();
	}

	orderStatusChange(status: string) {
		switch (status) {
			case "noPaymentRequired":
				this.orderRequiresPayment = false;
				break;
			case "orderAssembling":
				this.orderSteps.assembled = true;
				this.orderProgress = 14;
				break;
			case "orderPaymentAuth":
				this.orderSteps.authorized = true;
				this.orderProgress = 28;
				break;
			case "orderSubmitted":
				this.orderSteps.submitted = true;
				this.orderProgress = 42;
				break;
			case "orderQueued":
				this.orderSteps.queued = true;
				this.orderProgress = 56;
				break;
			case "orderSentToPos":
				this.orderSteps.sentToPos = true;
				this.orderProgress = 70;
				break;
			case "orderInjected":
				if (!this.orderSteps.mobileCheckSave) {
					this.orderSteps.injected = true;
					this.orderProgress = 84;
				}

				break;
			case "orderMobileCheckSave":
				this.orderSteps.injected = true;
				this.orderProgress = 84;
				this.orderSteps.mobileCheckSave = true;
				this.orderProgress = 100;
				this.orderCompleteEmitter.emit("success");
				break;
			case "orderError":
				this.orderCompleteEmitter.emit("error");
				break;
			default:
				break;
		}
	}
}
